// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"38461c4d","210":"f7c151b9","254":"801cc1c6","260":"af994675","402":"8a4475ce","663":"6464b4e7","779":"2830f314","787":"5ad96c4b","811":"f44906df","819":"e335f00c","856":"7dc2f350"}[chunkId] + ".chunk.js";
};